import { render, staticRenderFns } from "./randomSelect.vue?vue&type=template&id=3fa8e3a5"
import script from "./randomSelect.vue?vue&type=script&lang=js"
export * from "./randomSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports